<template>
    <div class="menu">
        <b-container fluid>
            <b-row>
                <b-col>
                    <b-navbar toggleable="lg">
                    <b-navbar-brand ><img class="logo" src="../assets/img/logoek.png" alt="logo"></b-navbar-brand>

                    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                    <b-collapse id="nav-collapse" is-nav>
                    
                        <!-- Right aligned nav items -->
                        <b-navbar-nav class="ml-auto">
                            <b-nav-item href="#nosotros">Nosotros</b-nav-item>
                            <b-nav-item href="#espacio">Nuestro espacio</b-nav-item>
                            <b-nav-item href="#cursos">Talleres y Cursos</b-nav-item>
                            <b-nav-item href="#cursos">Calendario</b-nav-item>
                            <b-nav-item class="contact" href="#contacto">Contacto</b-nav-item>
                        </b-navbar-nav>
                    </b-collapse>
                </b-navbar>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>
.menu{
    background: #5D867C;
    position: fixed;
    width: 100%;
    z-index: 999;
}
.navbar-light .navbar-nav .nav-link{
    color: #fff;
    font-size: 18px;
    padding-right: 1.5rem;
    padding-left: 1.5rem;
}

.navbar-light .navbar-nav .nav-link:focus,
.navbar-light .navbar-nav .nav-link:hover,
.navbar-light .navbar-nav .nav-link:active{
    color: #fff;
}

.navbar-light .navbar-nav .contact .nav-link{
    background: #fff !important;
    color: #5D867C !important;
    border-radius: 30px;
}
.navbar-light .navbar-toggler{
    border: none !important;
}
@media (max-width: 992px){
    .logo{
        width: 100px;
    }
}
</style>